<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTr } from '@/composables/useTr'
import { ICONS } from '@/composables/useIcons'
import { settingsCards } from '@/data/nav'

const { tr, locale } = useTr()
const route = useRoute()
const router = useRouter()
const currentPage = computed(() => route.meta?.pageId as string | undefined)

function go(id: string) {
  router.push({ name: id })
}
</script>

<template>
  <aside class="settings-sub-nav">
    <div class="ssn-header">{{ tr('设置', 'SETTINGS') }}</div>
    <div
      v-for="s in settingsCards"
      :key="s.id"
      class="ssn-item"
      :class="{ active: currentPage === s.id }"
      @click="go(s.id)"
    >
      <span class="ssn-icon" v-html="ICONS[s.icon]" />
      <span>{{ locale === 'en' ? s.labelEn : s.label }}</span>
    </div>
  </aside>
</template>
